angular
  .module('picmonicng')
  .controller('addToPlaylist', [
    '$scope',
    '$filter',
    'PlaylistService',
    function ($scope, $filter, PlaylistService) {
      $scope.PlaylistService = PlaylistService;

      $scope.addToPlaylist = function (event) {
        if (typeof event != 'undefined') {
          event.stopPropagation();
        }

        if (!$scope.picmonic.loading) {
          $scope.picmonic.loading = true;
          PlaylistService.addCard($scope.picmonic.card_id, PlaylistService.getCurrentPlaylist()).then(function () {
            $scope.picmonic.loading = false;
          });
        }
      };

      $scope.removeFromPlaylist = function (event) {
        if (typeof event != 'undefined') {
          event.stopPropagation();
        }

        if (!$scope.picmonic.loading) {
          $scope.picmonic.loading = true;
          PlaylistService.removeCard($scope.picmonic.card_id, PlaylistService.getCurrentPlaylist()).then(function () {
            $scope.picmonic.loading = false;
          });
        }
      };
    },
  ])
  .directive('addToPlaylist', [
    function () {
      return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
          picmonic: '=',
        },
        template:
          '<div class="add-to-playlist-wrapper" ng-show="PlaylistService.getCurrentPlaylist()">' +
          '<i class="material-icons mm" ng-show="!picmonic.loading && PlaylistService.getCurrentPlaylist().picmonics.indexOf(picmonic.card_id) == -1" ng-click="addToPlaylist($event)" title="Add to most recent Playlist">playlist_add</i>' +
          '<i class="material-icons mm in-playlist" ng-show="!picmonic.loading && PlaylistService.getCurrentPlaylist().picmonics.indexOf(picmonic.card_id) != -1" ng-click="removeFromPlaylist($event)" title="Delete from most recent Playlist"></i>' +
          '<pls-loading-icon size="x-small" ng-show="picmonic.loading"></pls-loading-icon>' +
          '</div>',
        controller: 'addToPlaylist',
      };
    },
  ]);
